interface CustomTheme {
  defaultStyle: unknown;
  styles: unknown;
  layout: unknown;
}

export const BorderedCell = (
  content: unknown,
  height?: any,
  colSpan?: number
) => ({
  table: {
    widths: ['*'],
    body: [[content]],
    heights: height || 'auto'
  },
  heights: '100%',
  layout: 'customTheme',
  colSpan: colSpan || 1
});

export const CellSeparator = () => ({
  text: ' ',
  style: { fontSize: 7 }
});

export const customTheme: CustomTheme = {
  defaultStyle: {
    fontSize: 10
  },
  styles: {
    titleBold: {
      bold: true,
      alignment: 'center'
    },
    titleRight: {
      alignment: 'left'
    },
    centerArea: {
      alignment: 'center'
    },
    centerAreaText: {
      margin: [0, 50],
      alignment: 'center'
    },
    signCell: {
      alignment: 'center',
      margin: 20
    }
  },
  layout: {
    hLineColor: () => '#b6c5e3', // Sale cualquier cosa con #F5F7FBC2
    vLineColor: () => '#b6c5e3'
  }
};

export const tableBorderedContainer = {
  hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 1 : 0),
  vLineWidth: (i, node) => (i === 0 || i === node.table.body[0].length ? 1 : 0),
  hLineColor: () => '#b6c5e3',
  vLineColor: () => '#b6c5e3'
};

export const borderedContainer = {
  ...tableBorderedContainer,
  paddingBottom: () => 10,
  paddingTop: () => 10
};

export const calculateWidths = (widthLength: number): number[] => {
  if (widthLength <= 10) {
    return Array(widthLength).fill(51);
  }
  if (widthLength > 15) {
    if (widthLength > 20) {
      return Array(widthLength).fill(19);
    }
    return Array(widthLength).fill(20);
  }
  return Array(widthLength).fill(widthLength);
};
